var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPolice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 880,
    height: 880,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a",
    clipPathUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 660h660V0H0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M.42.376h657.329v657.329H.42Z",
    style: {
      fill: "#e39400",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "matrix(1.33333 0 0 -1.33333 0 880)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c164.181 0 298.086 133.906 298.086 298.085 0 164.181-133.905 298.087-298.086 298.087-164.182 0-298.087-133.906-298.087-298.087C-298.087 133.906-164.182 0 0 0",
    style: {
      fill: "#eaa60c",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(329.086 30.955)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c133.763 0 242.2-108.437 242.2-242.201 0-133.765-108.437-242.203-242.2-242.203-133.765 0-242.202 108.438-242.202 242.203C-242.202-108.437-133.765 0 0 0",
    style: {
      fill: "#efb415",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(329.086 571.243)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c102.901 0 186.317-83.418 186.317-186.318 0-102.903-83.416-186.321-186.317-186.321-102.901 0-186.319 83.418-186.319 186.321C-186.319-83.418-102.901 0 0 0",
    style: {
      fill: "#f5c21e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(329.086 515.36)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c72.036 0 130.434-58.397 130.434-130.434S72.036-260.868 0-260.868c-72.038 0-130.435 58.397-130.435 130.434S-72.038 0 0 0",
    style: {
      fill: "#facf27",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(329.086 459.475)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c41.061 0 74.55 33.49 74.55 74.551 0 41.062-33.489 74.55-74.55 74.55s-74.55-33.488-74.55-74.55C-74.55 33.49-41.061 0 0 0",
    style: {
      fill: "#ffdd30",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(329.086 254.49)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 2.111 125.243 21.957 27.446-55.172 89.597-78.554 46.921.527 45.867 15.027-35.586 42.295-16.655 12.006 29.309v1.583l-7.908 42.176 16.872-43.759-7.043-34.791 28.131-11.077 60.744-79.928 48.123 60.155-3.163 105.44 43.616 20.409-33.072 70.272.891 18.906-36.74 17.473-1.318 31.106 7.644-27.679 30.918-10.156 2.825 59.975 12.651-86.461 19.771-28.867 25.042 29.395-20.426-36.134 17.636-25.749 77.934 36.465 2.849 74.418-38.451 31.138 38.964-17.732 1.101 28.797 24.252 37.959-10.545-44.285 2.904-50.58 51.663 4.455 14.499 34.795-11.335-42.703-53.984-11.256 3.635-63.349-40.191-25.213 67.342-11.686h-85.972l-58.963-36.989 4.157-76.439 32.989 4.163 6.037 44.419 36.378 25.305-27.416-30.051.821-37.677 39.513 4.987 47.449 58.521 81.188.526-73.808-13.707-8.894-16.833 33.935-8.996-38.331.676-16.232-30.731 62.207-33.741-87.761 17.347-93.986-29.937-23.525-34.921 74.262-14.695 61.356 21.634-56.611-41.668-54.88 5.393 8.485-38.606-22.868 40.018-26.784 2.633-19.149-28.423L97.008 0Z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(177.991 .376)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-7.569-2.229 6.186-10.846 4.956 7.9zm-3.921 5.676-8.042-.203 3.635-6.371 7.435 2.19zM-22.885-5.182-9.799-1.33l-3.856 6.761-14.238-.359ZM1.354-20.881l-2.797 4.905-4.85-7.731zm10.407 3.849L4.495-6.509l-5.039-8.035 3.315-5.814zm-.24-10.955-9.047 5.34a.734.734 0 0 0-.281.294l-.09.159-8.739-3.229 16.309-13.91zm31.125 17.1L13.02-28.071 11.2-39.228l38.466 24.674zm-29.519-7.232-9.465-3.498 8.116-4.791zM37.123-8.001l-22.374-9.436-1.421-8.734L41.084-10.07zM17.404-1.142 21.521.152l-3.599 1.88zm5.984.316-6.252-1.965-.88-5.403L29.942-4.25zm8.465-4.422L15.99-9.818l-.958-5.884 20.379 8.595zM6.285 5.329l-9.979 2.644L.893 1.329a.917.917 0 0 0 .051-.076L5.061-4.71l.028-.038 8.1-11.731.221.094 1.144 7.01zm10.221-2.707L8.298 4.795l6.64-11.808.796 4.896.008.045zm7.221 3.02-4.763-2.477 3.942-2.059zm7.181 3.732-5.511-2.865-1.11-6.124 6.877-3.592zm-19.42-3.881 5.774-1.53 4.031 2.097ZM-.436 8.652 6.859 6.72l17.665 1.02 3.815 1.984Zm44.532 7.577.227-25.707a.743.743 0 0 0-.191-.505l6.253-3.267-.544 32.465zm-5.825-3.028-.363-19.933 4.697-2.454.225.13-.216 24.516zm-5.89-3.061.286-14.135 3.763-1.964c.025 3.809-.093 14.314.197 18.307zm-47.495.858 2.311-4.055 7.872.197-.981 1.42zm-17.999 4.767 4.5-9.219 14.12.353-2.641 4.634zm84.43 4.218.57-34.017 30.391-15.88a.743.743 0 1 0-.689-1.318L51.188-15.349 10.879-41.208 6.752-66.542a.748.748 0 0 0-.856-.617.748.748 0 0 0-.617.856l4.114 25.25-17.632 15.037-14.22-5.256a.746.746 0 1 0-.515 1.401l14.392 5.319 6.302 10.045L-9.039-2.66l-13.184-3.881 2.815-5.766.017-.033 4.061-8.318a.747.747 0 0 0-1.342-.654l-3.718 7.617-24.357-14.227a.745.745 0 0 0-1.021.268.748.748 0 0 0 .268 1.022l24.451 14.283-2.888 5.917-.025.053-4.08 8.354-27.344-5.73a.74.74 0 0 0-.878.578.742.742 0 0 0 .576.881l26.97 5.652-1.012 2.076-.03.056-5.265 10.783-27.423 7.265a.746.746 0 0 0 .38 1.442l27.726-7.345.065-.018 17.794-4.712.068-.018.014-.006 11.032-2.921 36.796 1.37 45.416 23.608a.747.747 0 0 0 .69-1.325z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(353.598 455.122)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.747.747 0 0 0 .735.755.749.749 0 0 0 .755-.737l.39-32.279 12.471-30.187a.746.746 0 0 0-.405-.972.749.749 0 0 0-.973.405L.446-32.696a.767.767 0 0 0-.053.273z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(407.9 326.48)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.747.747 0 0 0 .21-1.477l-41.98-6.007a.585.585 0 0 0-.167-.006l-27.804 2.372a.745.745 0 0 0-.684.804.75.75 0 0 0 .807.685l27.726-2.368z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(450.911 300.813)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.744.744 0 1 0-1.214.864L4.764 9.3a.745.745 0 0 0 1.213.002l6.156-7.876a.74.74 0 0 0 .125-.678L9.483-8.27a.747.747 0 0 0-1.107-.415L-5.973.224a.745.745 0 0 0-.24 1.027L4.676 16.556a.745.745 0 0 0 1.184.039L19.485 2.354a.744.744 0 0 0 .148-.802l-7.205-17.086a.745.745 0 0 0-.975-.398l-.118.063L-14.407.951a.746.746 0 0 0-.095 1.176l19.164 20.69a.743.743 0 0 0 1.047.046L26.971 3.47a.751.751 0 0 0 .167-.884l-11.384-26.19a.743.743 0 0 0-.98-.383.806.806 0 0 0-.196.122l-33.19 25.202a.744.744 0 0 0-.143 1.043.74.74 0 0 0 1.04.142L14.766-22.14 25.572 2.726 5.251 21.265-12.852 1.717l24.255-15.85 6.669 15.814-12.703 13.28-9.88-13.889 12.853-7.98L10.721.813 5.4 7.62Z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(403.558 294.152)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.746.746 0 0 0-.108 1.048.746.746 0 0 0 1.047.108l6.91-5.603a.745.745 0 0 0-.471-1.323.734.734 0 0 0-.518.208Z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(421.352 277.613)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a.744.744 0 0 0 .601 1.36l12.293-5.458a.742.742 0 0 0-.603-1.358z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(425.178 285.926)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0 6.292 6.65-4.823 2.942-.017.011-3.486 2.125Zm-8.128-8.588 6.846 7.234-2.445 14.116-6.014 3.666zm-6.918-7.31 5.521 5.832-1.771 27.443-4.901 2.991zm-6.118-6.468 4.679 4.944-1.233 38.716-6.164 3.763zm-5.443-5.752 4.036 4.264-2.861 49.855-6.103 3.721zM10.699-5.152 7.151 5.397.817-1.297Zm3.199-9.504-2.578 7.66L-.289-2.467-7.325-9.9zm2.756-8.195-2.202 6.544-22.968 5.149-5.733-6.062zm2.787-8.287-2.245 6.676-32.667 5.95-4.862-5.138 22.904-4.311.048-.011zM17.687 6.353l-9.195-.261 3.569-10.615Zm7.673.218-5.971-.169L12.724-6.49l2.437-7.25Zm4.693.133-3.005-.086L15.83-15.728l2.018-5.995Zm6.707.191-5.063-.145L18.56-23.844l2.082-6.192Zm6.772.191-5.128-.146-17.053-39.082 3.262-9.705Zm17.241.488-15.624-.443-19.791-51.186.566-1.685Zm-44.787 4.281-6.06-4.233 7.864.224Zm10.789 7.542-9.545-6.671 2.176-4.835 6.486.184zm3.278 2.29-1.694-1.184-.969-12.386 3.045.086Zm6.585 4.603-5.128-3.585.414-14.459 5.222.148Zm10.018 7.002-8.557-5.982.535-18.874 5.327.151Zm8.826 6.168-7.203-5.035-2.815-25.794 15.817.447ZM3.882 9.864l3.554-2.167 5.586 3.904zm-5.023 3.067 3.128-1.91 14.016 2.662 7.898 5.521zm-7.234 4.411 5.444-3.322 30.264 7.582.52.365zm-6.356 3.878 4.321-2.638 40.891 5.22 4.046 2.829zm-7.744 4.722 5.66-3.453 53.889 5.92 7.653 5.35zm-7.671 4.68 5.605-3.42 71.845 8.359 5.887 4.111zM.515-36.669l1.098 7.37-23.165 4.361-4.266-4.51zm-.735-4.927.515 3.443-27.273 7.481-4.534-4.79zm1.964 3.046-.495-3.331 23.344-4.575-.608 1.808zm1.335 8.976-1.116-7.494 21.453-5.882-3.43 10.192zm-75.74 84.382a.745.745 0 0 0 .776 1.273l39.652-24.187 87.963 9.555 15.233 10.646a.744.744 0 0 0 .855-1.22l-14.996-10.48 5.971-31.272 18.986.537a.744.744 0 1 0 .042-1.488l-19.229-.545L43.62-21.396l40.297-25.997a.749.749 0 0 0 .227-1.03.75.75 0 0 0-1.034-.226L42.805-22.643 35.036-34.53l26.162-38.643a.745.745 0 0 0-1.232-.834L34.153-35.881 26.532-47.54l20.652-61.401a.745.745 0 0 0-1.414-.474L25.142-48.083 1.026-43.36l-6.398-42.99a.746.746 0 1 0-1.476.216l6.409 43.063-32.288 6.325-5.664-5.987a.744.744 0 0 0-1.05-.03.745.745 0 0 0-.031 1.05l5.904 6.238a.947.947 0 0 0 .092.099l5.496 5.808-5.135 60.255z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(202.553 300.832)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.81 393.641h-1.492v86.989h1.492z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.264 0 4.34-.587 5.966-1.566L9.488.977l5.801-3.163L9.488-.605 7.764-3.003c.226-.24.43-.491.613-.751l2.562.976 6.394-3.889-6.062 2.24-1.956-1.448a5.208 5.208 0 0 0 .091-1.467l2.785-.116 3.692-4.679-4.218 2.901-2.764.029C7.621-11.915 4.119-13.86 0-13.86s-7.621 1.945-8.903 4.653l-2.764-.029-4.216-2.901 3.69 4.679 2.785.116a5.21 5.21 0 0 0 .093 1.467l-1.955 1.448-6.063-2.24 6.393 3.889 2.562-.976c.184.26.388.511.614.751L-9.49-.605l-5.799-1.581L-9.49.977l3.523-2.543C-4.342-.587-2.264 0 0 0",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(486.063 398)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.548 1.548 0 1 0 0-3.098A1.55 1.55 0 1 0 0 0m-6.459 0a1.548 1.548 0 1 0 0-3.098 1.55 1.55 0 0 0 0 3.098",
    style: {
      fill: "#f5c21e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(489.293 390.28)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.421 196.569h-1.493v86.989h1.493z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.264 0 4.34-.587 5.967-1.564L9.489.98l5.801-3.163L9.489-.601 7.764-3.003a6.21 6.21 0 0 0 .612-.752l2.564.979 6.393-3.889-6.063 2.239-1.956-1.446a5.149 5.149 0 0 0 .092-1.47l2.787-.114 3.69-4.679-4.218 2.899-2.763.031C7.622-11.913 4.121-13.859 0-13.859c-4.119 0-7.622 1.946-8.902 4.654l-2.762-.031-4.219-2.899 3.69 4.679 2.787.114a5.19 5.19 0 0 0 .091 1.47l-1.955 1.446-6.061-2.239 6.391 3.889 2.564-.979c.181.263.387.515.612.752L-9.489-.601l-5.8-1.582 5.8 3.163 3.526-2.544C-4.34-.587-2.264 0 0 0",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(96.674 200.928)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.55 1.55 0 1 0-.004-3.1A1.55 1.55 0 0 0 0 0m-6.458 0a1.549 1.549 0 1 0-.002-3.098A1.549 1.549 0 0 0-6.458 0",
    style: {
      fill: "#f5c21e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(99.904 193.209)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.394 189.495h-1.493v86.988h1.493z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.264 0 4.341-.587 5.966-1.564L9.489.977l5.801-3.163L9.489-.604 7.765-3.003c.226-.24.43-.491.612-.752l2.562.977 6.395-3.891-6.063 2.241-1.956-1.448a5.185 5.185 0 0 0 .091-1.466l2.786-.116 3.692-4.679-4.219 2.901-2.763.029C7.622-11.915 4.119-13.859 0-13.859c-4.118 0-7.621 1.944-8.903 4.652l-2.761-.029-4.219-2.901 3.69 4.679 2.786.116a5.157 5.157 0 0 0 .093 1.466l-1.955 1.448-6.064-2.241 6.393 3.891 2.562-.977c.184.261.388.512.614.752L-9.49-.604l-5.799-1.582L-9.49.977l3.523-2.541C-4.34-.587-2.264 0 0 0",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(440.647 193.853)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.55 1.55 0 0 0 0-3.098c-.857 0-1.548.694-1.548 1.55C-1.548-.695-.857 0 0 0m-6.46 0a1.55 1.55 0 1 0-1.548-1.548A1.55 1.55 0 0 0-6.46 0",
    style: {
      fill: "#f5c21e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(443.877 186.133)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.613 386.669h-1.493v86.989h1.493z",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c2.264 0 4.34-.587 5.966-1.566L9.489.978l5.801-3.164L9.489-.604 7.764-3.003c.225-.239.431-.49.613-.75l2.562.975 6.393-3.889-6.061 2.24-1.956-1.447a5.217 5.217 0 0 0 .092-1.468l2.785-.116 3.691-4.678-4.218 2.9-2.763.03C7.622-11.914 4.119-13.861 0-13.861c-4.12 0-7.621 1.947-8.903 4.655l-2.761-.03-4.219-2.9 3.69 4.678 2.787.116a5.44 5.44 0 0 0 .089 1.468l-1.953 1.447-6.063-2.24 6.393 3.889 2.564-.975c.182.26.384.511.61.75L-9.49-.604l-5.799-1.582L-9.49.978l3.523-2.544C-4.34-.587-2.263 0 0 0",
    style: {
      fill: "#452d00",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(289.866 391.028)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a1.549 1.549 0 1 0-.002-3.1A1.549 1.549 0 0 0 0 0m-6.457 0a1.55 1.55 0 1 0-.001-3.1A1.55 1.55 0 0 0-6.457 0",
    style: {
      fill: "#f5c21e",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(293.095 383.308)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-18.423-5.097 3.691 89.625 69.539 28.899-58.962-36.988zm73.436 125.115-12.514 1.59 42.968 26.623 2.355 125.639 2.903-50.581.842-14.711 3.637-63.347zM-131.182-99.537l15.752 16.15-62.737 80.135-86.739 40.232 78.553-46.919zm31.042-152.689-1.056 130.088 78.029 93.844L92.604-11.029l-98.517-34.7-59.71-88.634 7.381-117.863z",
    style: {
      fill: "#261900",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(333.241 252.602)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolice);
export default __webpack_public_path__ + "static/media/police.97028ffa2dc278b9ed0b0b946a6a096a.svg";
export { ForwardRef as ReactComponent };